import { Injectable } from '@angular/core';
import { BasecrudService } from 'src/app/shared/basecrud.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BannerLeedsService extends BasecrudService {

  constructor(http: HttpClient) {
    super(http, 'bannerleeds');
  }

  public GetSlider(): any {
    return this.GetValue('bannerleeds/getslider');
  }
}
